/**
 * Chakra UI v2 theme, built from `tokens.ts`.
 *
 * Phase 2 applies the mockup's visual contract globally (the redesigned shell
 * ships on `dev`, so the whole app adopts it):
 *   - `fonts` → Inter (loaded in `public/index.html`).
 *   - `radii` → the mockup ramp (sm 4px · md 6px · lg 8px · xl 12px · full).
 *   - `shadows` → the four mockup elevations, exposed both as named aliases
 *     (`card`/`panel`/`modal`/`toast`) and numeric (`1`..`4`) keys.
 *   - `semanticTokens.colors` → intention-named aliases (dark-mode-ready).
 *
 * Legacy `brand` accents are preserved verbatim so existing code reading
 * `theme.colors.brand.*` keeps working. Spacing and font sizes already match
 * Chakra's defaults (see `tokens.ts`), so they are not overridden.
 */

import { extendTheme } from "@chakra-ui/react";
import {
  BACKGROUND,
  BRAND_LEGACY,
  FONT_FAMILY,
  RADII,
  SHADOW,
  TEAL,
} from "./tokens";
import { semanticColors } from "./semanticTokens";

const theme = extendTheme({
  fonts: {
    heading: FONT_FAMILY.heading,
    body: FONT_FAMILY.body,
    mono: FONT_FAMILY.mono,
  },
  colors: {
    // Legacy accents preserved verbatim + additive teal ramp for components.
    brand: {
      ...TEAL,
      ...BRAND_LEGACY,
    },
  },
  radii: {
    sm: RADII.sm,
    md: RADII.md,
    lg: RADII.lg,
    xl: RADII.xl,
    full: RADII.full,
  },
  shadows: {
    // Named + numeric aliases for the four mockup elevations.
    card: SHADOW.card,
    panel: SHADOW.panel,
    modal: SHADOW.modal,
    toast: SHADOW.toast,
    1: SHADOW.card,
    2: SHADOW.panel,
    3: SHADOW.modal,
    4: SHADOW.toast,
  },
  semanticTokens: {
    colors: semanticColors,
  },
  styles: {
    global: {
      "html, body": {
        backgroundColor: BACKGROUND.page,
      },
    },
  },
});

export default theme;
